import { render, staticRenderFns } from "./DashSprintView.vue?vue&type=template&id=5efb8656&scoped=true&"
import script from "./DashSprintView.vue?vue&type=script&lang=ts&"
export * from "./DashSprintView.vue?vue&type=script&lang=ts&"
import style0 from "./DashSprintView.vue?vue&type=style&index=0&id=5efb8656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb8656",
  null
  
)

export default component.exports